const compactFormatter = new Intl.NumberFormat("da-DK", {
  notation: "compact",
  maximumFractionDigits: 1,
});

const integerFormatter = new Intl.NumberFormat("da-DK", {
  maximumFractionDigits: 0,
});

const decimalFormatter = new Intl.NumberFormat("da-DK", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const rateFormatter = new Intl.NumberFormat("da-DK", {
  minimumFractionDigits: 4,
  maximumFractionDigits: 6,
});

export function formatInt(n: number | null | undefined): string {
  if (n === null || n === undefined) return "—";
  return integerFormatter.format(n);
}

export function formatCompact(n: number | null | undefined): string {
  if (n === null || n === undefined) return "—";
  return compactFormatter.format(n);
}

export function formatMoney(
  amount: number | null | undefined,
  currency: string = "DKK",
): string {
  if (amount === null || amount === undefined) return "—";
  return `${decimalFormatter.format(amount)} ${currency}`;
}

export function formatRate(rate: number | null | undefined): string {
  if (rate === null || rate === undefined) return "—";
  return rateFormatter.format(rate);
}

export function formatDateShort(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("da-DK", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString("da-DK", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatRelative(iso: string | null | undefined): string {
  if (!iso) return "Aldrig";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  const diffMs = Date.now() - d.getTime();
  const min = 60_000;
  const hr = 60 * min;
  const day = 24 * hr;
  if (diffMs < min) return "Lige nu";
  if (diffMs < hr) return `${Math.floor(diffMs / min)} min siden`;
  if (diffMs < day) return `${Math.floor(diffMs / hr)} t siden`;
  if (diffMs < 30 * day) return `${Math.floor(diffMs / day)} d siden`;
  return formatDateShort(iso);
}

const BILLING_PERIOD_DA: Record<string, string> = {
  weekly: "ugentligt",
  monthly: "månedligt",
  quarterly: "kvartalsvis",
  yearly: "årligt",
};

export function planSummary(plan: {
  planType: string;
  billingPeriod: string | null;
  baseFee: number | null;
  includedCalls: number | null;
  overageRate: number | null;
  currency: string;
} | null): string {
  if (!plan) return "Ingen plan";
  if (plan.planType === "FreeTierCap") {
    return `Gratis · ${formatCompact(plan.includedCalls ?? 0)} kald`;
  }
  if (plan.planType === "FlatPerCall") {
    return `${formatRate(plan.overageRate)} ${plan.currency} / kald`;
  }
  const period = plan.billingPeriod
    ? (BILLING_PERIOD_DA[plan.billingPeriod.toLowerCase()] ?? plan.billingPeriod.toLowerCase())
    : "";
  return `${formatMoney(plan.baseFee, plan.currency)} ${period}`.trim();
}
